import { CustomerOrderListPage } from '@/pages/customer-portal/orders/CustomerOrderListPage';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/customer/_customer-authenticated/orders/')({
	component: CustomerOrderListRoute,
});

function CustomerOrderListRoute() {
	return <CustomerOrderListPage />;
}
